import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    underwriterRates: [],
    loading: false,
    saving: false,
    deleting: false
};

export default function underwriterRate(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_UNDERWRITER_RATE:
            newState.loading = true;
            break;

        case actions.SAVING_UNDERWRITER_RATE:
            newState.saving = true;
            break;

        case actions.RECEIVED_UNDERWRITER_RATES:
            newState.loading = false;
            newState.underwriterRates = utils.mapById(action.payload)
            break;

        case actions.SAVED_UNDERWRITER_RATE:
            let found = false;

            for (let i = 0; i < newState.underwriterRates.length; i++) {
                if(newState.underwriterRates[i].id === action.payload.id){
                    found = true;

                    newState.underwriterRates[i] = action.payload;
                }
            }

            if(!found) {
                newState.underwriterRates.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_UNDERWRITER_RATES:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_UNDERWRITER_RATE:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_UNDERWRITER_RATE:
            newState.deleting = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/underwriterRate.js